module.exports = __webpack_public_path__ + "img/LogoTh.b2c94243.png";